/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderComponent } from './providerComponent';


export interface ComponentsInventory { 
    /**
     * List of component
     */
    components: Array<ProviderComponent>;
    /**
     * Report time for inventory information
     */
    report_time: Date;
}

